const ProductReducer = (state, action) => {

    switch (action.type) {

        case 'SET_SINGLE_PITCH':

            return {
                ...state,
                isSingleLoading: false,
                singlePitch: action.payload,
            }

        case 'SINGLE_PITCH_API_ERROR':
            return {
                ...state,
                isSingleLoading: false,
                isError: true,
            }

        default:
            return state;
    }
}

export default ProductReducer;
